import { Box, TextField } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import PropTypes from "prop-types";
import React from "react";
import SlideUpTransition from "./fundamentals/SlideUpTransition";
import ConfirmButton from "./fundamentals/ConfirmButton";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  commentBox: {
    width: "80%",
    margin: "20px auto",
  },
}));

const PublishSeniorityListDialog = (props) => {
  const classes = useStyles();
  const handleCommentsChange = (event) => {
    props.onSetComments(event.target.value);
  };

  return (
    <Dialog
      sx={{ width: "900px", margin: "auto" }}
      maxWidth="md"
      open={props.isDialogOpen}
      TransitionComponent={SlideUpTransition}
      keepMounted
      onClose={() => props.onClickDialogClose()}
      data-testid="create-bid-dialog"
    >
      <Box p={1}>
        <DialogTitle id="publish-seniority-list-dialog-title">Publish Seniority List</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <p>
              You are publishing this Seniority List for{" "}
              <b>
                {props.station} | {props.workgroup} | {props.seniorityListType}
              </b>
              . <br /> Once you click Publish, you may export the Seniority List to a PDF from the Last Published tab.
            </p>
            <TextField
              className={classes.commentBox}
              multiline
              rows={2}
              label="Comments (Optional)"
              placeholder="Enter comments here"
              InputLabelProps={{ shrink: true }}
              onChange={handleCommentsChange}
              inputProps={{ maxLength: 100 }}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ConfirmButton variant="outlined" color="primary" onClick={() => props.onClickDialogClose()}>
            Cancel
          </ConfirmButton>
          <ConfirmButton
            variant="contained"
            color="primary"
            onClick={props.onSubmitPubSLEvent}
            isLoading={props.isPublishSLLoading}
          >
            {props.yesTitle ? props.yesTitle : "Yes"}
          </ConfirmButton>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

PublishSeniorityListDialog.propTypes = {
  isDialogOpen: PropTypes.bool.isRequired,
  onSetComments: PropTypes.func.isRequired,
  onClickDialogClose: PropTypes.func.isRequired,
  station: PropTypes.string.isRequired,
  workgroup: PropTypes.string.isRequired,
  seniorityListType: PropTypes.string.isRequired,
  isPublishSLLoading: PropTypes.bool.isRequired,
  onSubmitPubSLEvent: PropTypes.func.isRequired,
};

export default PublishSeniorityListDialog;
